import axios, {AxiosResponse} from 'axios'

// List formType
const formTypeList = async ({params}) => {
  const response = await axios.get('/api/form-type/list', params)
  return response.data
}

// Create Or Update new formType
const formTypeCreate = async ({data}) => {
  await axios.post('/api/form-type/store', data)
}

// Edit formType
const formTypeEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/form-type/edit/${id}`)
  return response.data
}

// Delete formType
const formTypeDelete = async (id: string) => {
  await axios.get(`/api/form-type/destroy/${id}`)
}

const formService = {
  formTypeList,
  formTypeCreate,
  formTypeEdit,
  formTypeDelete,
}

export default formService
